import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/custom-software-solutions/components/SolutionsInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Header.tsx");
